export type NavLink = {
  label: string
  href: string
}

export const navLinks: NavLink[] = [
  { label: 'Home', href: '#top' },
  { label: 'Procedures', href: '#procedures' },
  { label: 'Med Spa', href: '#med-spa' },
  { label: 'About', href: '#about' },
  { label: 'Resources', href: '#resources' },
]

export const clinic = {
  name: "Sara's",
  fullName: "Sara's Plastic Surgery & Med Spa",
  phoneDisplay: '(305) 603-9589',
  phoneHref: 'tel:+13056039589',
  email: 'concierge@sarasplasticsurgery.com',
  addressLine1: '10260 SW 56th St Suite 103',
  addressLine2: 'Miami, FL 33165',
  hours: 'Mon – Fri · 9:00am – 5:00pm',
}
